export const PROFILE_REQUEST = "USERS_PROFILE_REQUEST";
export const PROFILE_FAILURE = "USERS_PROFILE_FAILURE";

export const USERS_GET_PROFILE_SUCCESS = "USERS_GET_PROFILE_SUCCESS";
export const USERS_UPDATE_PROFILE_SUCCESS = "USERS_UPDATE_PROFILE_SUCCESS";
export const ADMIN_UPDATE_PROFILE_SUCCESS = "ADMIN_UPDATE_PROFILE_SUCCESS";

export const ADMIN_GET_MEMBER_SUCCESS = "ADMIN_GET_MEMBER_SUCCESS";
export const ADMIN_DEACTIVATE_MEMBER_SUCCESS = "ADMIN_DEACTIVATE_MEMBER_SUCCESS";

export const ADMIN_SELLER_SUCCESS = "ADMIN_SELLER_SUCCESS";
export const ADMIN_BUYER_SUCCESS = "ADMIN_BUYER_SUCCESS";
